// extracted by mini-css-extract-plugin
export const buttonWrapper = "PopupCloseButton__buttonWrapper__4ke4u";